import { render, staticRenderFns } from "./NumbersList.vue?vue&type=template&id=1c0c6fa5&scoped=true&"
import script from "./NumbersList.vue?vue&type=script&lang=js&"
export * from "./NumbersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c6fa5",
  null
  
)

export default component.exports